import type React from 'react';
import clsx from 'clsx';
import styles from './TestExecution.module.css';

interface ConfirmModalProps {
  testsToDeleteCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({ testsToDeleteCount, onConfirm, onCancel }) => {
  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalIcon}>⚠️</div>
          <h2 className={styles.modalTitle}>{testsToDeleteCount > 0 ? 'Delete Existing Tests?' : 'Generate Tests?'}</h2>
        </div>
        <div className={styles.modalBody}>
          {testsToDeleteCount > 0 ? (
            <>
              <p>You have existing tests that will be permanently deleted.</p>
              <div className={styles.modalTestCount}>
                📋 {testsToDeleteCount} test{testsToDeleteCount !== 1 ? 's' : ''} will be deleted
              </div>
              <p>Generating new tests will delete all existing tests and create new ones from scratch.</p>
            </>
          ) : (
            <>
              <p>This will generate new security tests from hypotheses.</p>
              <p>The test generation process will analyze your API specification and create automated test cases.</p>
            </>
          )}
          <p style={{ marginBottom: 0 }}>
            <strong>Do you want to continue?</strong>
          </p>
        </div>
        <div className={styles.modalActions}>
          <button className={clsx(styles.modalButton, styles.cancelButton)} onClick={onCancel}>
            Cancel
          </button>
          <button className={clsx(styles.modalButton, styles.confirmButton)} onClick={onConfirm}>
            {testsToDeleteCount > 0 ? 'Delete & Generate New Tests' : 'Generate Tests'}
          </button>
        </div>
      </div>
    </div>
  );
};
